export default __webpack_public_path__ + "static/media/network-graph-0-rMAX.6f266863.jpg";